import React, { useState } from "react";
import "./Contact.scss";
import contactImage from "../../../Assets/Images/contact.jpg";
import axios from "axios";
export default function Contact() {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState([]);

  const validate = () => {
    let error = [];
    let formIsValid = true;

    if (!formData.name) {
      formIsValid = false;
      error["name"] = "Please Enter Name";
    }
    if (!formData.email) {
      formIsValid = false;
      error["email"] = "Please Enter Email";
    } else if (
      !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(formData.email)
    ) {
      formIsValid = false;
      error["email"] = "Please enter valid email";
    }
    if (!formData.subject) {
      formIsValid = false;
      error["subject"] = "Please Enter subject";
    }
    if (!formData.message) {
      formIsValid = false;
      error["message"] = "Please Enter message";
    }
    setErrors(error);
    return formIsValid;
  };


  const handleChange = (e) => {
    let { name, value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    if (validate()) {
      const data = {
        email: formData.email,
        name: formData.name,
        subject: formData.subject,
        message: formData.message,
      };
      axios
        .post("https://api.utilities.rejoicehub.com/api/contact", data)
        .then((res) => {
          console.log("res", res);
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  };

  return (
    <>
      <section className="container" id="contact-page-align">
        <div className="contact-page-align">
          <div className="contact-details">
            <p>CONTACT US</p>
            <span>
            Do You Have Any Questions? We’ll Be Happy To Assist!

            </span>
          </div>
          <div className="contact-grid">
            <div className="contact-grid-items">
              <img src={contactImage} alt="contact" />
            </div>
            <div className="contact-grid-items">
              <div className="from-grid">
                <div className="input-design">
                  <input
                    type="name"
                    name="name"
                    required
                    placeholder="Name"
                    onChange={(e) => handleChange(e)}
                  />
                  <span
                    style={{
                      color: "red",
                      top: "0px",
                      fontSize: "12px",
                    }}
                  >
                    {errors["name"]}
                  </span>
                </div>

                <div className="input-design">
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="Email"
                    onChange={(e) => handleChange(e)}
                  />
                  <span
                    style={{
                      color: "red",
                      top: "0px",
                      fontSize: "12px",
                    }}
                  >
                    {errors["email"]}
                  </span>
                </div>
              </div>
              <div className="form-sub-grid">
                <div className="input-design">
                  <input
                    type="subject"
                    name="subject"
                    required
                    placeholder="Subject"
                    onChange={(e) => handleChange(e)}
                  />
                </div>
                <span
                  style={{
                    color: "red",
                    top: "0px",
                    fontSize: "12px",
                  }}
                >
                  {errors["subject"]}
                </span>
              </div>
              <div className="form-sub-grid">
                <div className="input-design">
                  <textarea
                    id="w3review"
                    placeholder="Message"
                    name="message"
                    rows="9"
                    cols="50"
                    onChange={(e) => handleChange(e)}
                  ></textarea>
                </div>
                <span
                  style={{
                    color: "red",
                    top: "0px",
                    fontSize: "12px",
                  }}
                >
                  {errors["message"]}
                </span>
              </div>
              <div className="send-message" onClick={handleSubmit}>
                <button>Send Message</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
